<script>
import { SFacebook } from 'vue-socials';
import { SFacebookMessenger } from 'vue-socials';
import { STwitter } from 'vue-socials';
import { SLinkedIn } from 'vue-socials';
import { SWhatsApp } from 'vue-socials';
import TwInput from '@/components/generic/forms/tw-input.vue'
import QrcodeVue, { QrcodeCanvas, QrcodeSvg } from 'qrcode.vue'
import TwGridDual from '@/components/generic/tw-grid-dual.vue'
import TwButton from '@/components/generic/tw-button.vue'
import { FontAwesomeIcon as Icon } from '@fortawesome/vue-fontawesome'
import FundraiserPageShareOverEmail from '@/components/fundraiser-pages/fundraiser-page-share-over-email.vue'
import TwWhatsappSharingButton from '@/components/socials-sharing/tw-whatsapp-sharing-button.vue'
export default {
  name: 'FundraiserPageSocialsShare',
  components: {
    TwWhatsappSharingButton,
    FundraiserPageShareOverEmail,
    Icon,
    TwButton,
    TwGridDual,
    TwInput,
    SFacebook,
    SFacebookMessenger,
    STwitter,
    SLinkedIn,
    SWhatsApp,
    QrcodeVue,
    QrcodeCanvas,
    QrcodeSvg,
  },
  props: {
    fundraiserPage: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      sharing: {
        url: this.fundraiserPage.url_sharing,
        title: this.fundraiserPage.title,
        text: this.fundraiserPage.short_description,
        content: this.fundraiserPage.short_description,
        quote: this.fundraiserPage.short_description,
        hashtags: ['campaign','grouprev','fundraiser'],
        hashtag: '#grouprev',
        via: 'grouprev'
      },
      networks: [
        { network: 'SFacebook', name: 'Facebook', icon: 'fab fah fa-lg fa-facebook', color: '#1877f2' },
        // { network: 'SFacebookMessenger', name: 'Facebook Messenger', icon: 'fab fah fa-lg fa-facebook-messenger', color: '#0084ff' },
        { network: 'SLinkedIn', name: 'LinkedIn', icon: 'fab fah fa-lg fa-linkedin', color: '#007bb5' },
        { network: 'STwitter', name: 'X', icon: 'fab fah fa-lg fa-x-twitter', color: '#000' },
        { network: 'tw-whatsapp-sharing-button', name: 'Whatsapp', icon: 'fab fah fa-lg fa-whatsapp', color: '#25d366' },
      ]
    }
  }
}
</script>

<template>
  <div>
    <tw-input label="Fundraiser URL:" class="mb-2" :model-value="fundraiserPage.url_sharing" disabled />
    <tw-grid-dual>
      <div class="p-4">
        <component
          :is="network.network"
          v-for="network in networks"
          :key="network.network"
          :use-native-behavior="false"
          :share-options="sharing"
          class="btn btn-block mb-2 text-white py-4 text-md"
          :network="network.network"
          :style="{backgroundColor: network.color}"
        >
          <icon size="xl" :icon="network.icon" />
          <span>{{ network.name }}</span>
        </component>
        <fundraiser-page-share-over-email :fundraiser-page="fundraiserPage" />
      </div>
      <div class="p-4 flex justify-center items-center">
        <qrcode-canvas size="230" :value="fundraiserPage.url_sharing" level="H" />
      </div>
    </tw-grid-dual>
  </div>
</template>

<style scoped>

</style>
